import { render, staticRenderFns } from "./documents.vue?vue&type=template&id=5e36ad77&scoped=true&"
import script from "./documents.vue?vue&type=script&lang=js&"
export * from "./documents.vue?vue&type=script&lang=js&"
import style0 from "./documents.vue?vue&type=style&index=0&id=5e36ad77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e36ad77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e36ad77')) {
      api.createRecord('5e36ad77', component.options)
    } else {
      api.reload('5e36ad77', component.options)
    }
    module.hot.accept("./documents.vue?vue&type=template&id=5e36ad77&scoped=true&", function () {
      api.rerender('5e36ad77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/documents/documents.vue"
export default component.exports